export default __webpack_public_path__ + "static/media/Kibhoret.c6be5108.PNG";